export default {
  setSelectedProduct: ({ reviewsList }, payload) => {
    reviewsList.selectedProduct = payload;
  },
  setSelectedProducts: ({ productSearch }, payload) => {
    productSearch.selectedIds = payload || [];
  },
  setSelectedRatings: ({ productSearch }, payload) => {
    productSearch.selectedRatings = payload;
  },
  setReviewsListLoading: ({ reviewsList }, payload) => {
    reviewsList.loading = payload;
  },
  setReviewId: ({ reviewsList }, payload) => {
    reviewsList.pagination.filterBy.reviewId = payload;
  },
  setSortBy: ({ reviewsList }, payload) => {
    reviewsList.pagination.sortBy = payload;
  },
  setPublished: ({ reviewsList }, payload) => {
    reviewsList.pagination.published = payload;
  },
  setUnpublished: ({ reviewsList }, payload) => {
    reviewsList.pagination.unpublished = payload;
  },
  setDescending: ({ reviewsList }, payload) => {
    reviewsList.pagination.descending = payload;
  },
  setReviewsListPagination: ({ reviewsList }, payload) => {
    reviewsList.pagination = payload;
  },
  loadReviewsListSuccess: ({ reviewsList, sellerReviews }, payload) => {
    reviewsList.pagination.averageRating = payload.averageRating;
    reviewsList.pagination.totalItems = payload.recordsTotal;
    reviewsList.pagination.filteredItems = payload.recordsFiltered;
    reviewsList.pagination.rowsPerPage = payload.dashboardReviewsPerPage;
    sellerReviews.pagination.rowsPerPage = payload.dashboardReviewsPerPage;
    reviewsList.data = payload.data;
    reviewsList.numUnpublished = payload.numUnpublished;
    reviewsList.carouselReviewsCount = payload.carouselReviewsCount;
    reviewsList.importing = payload.importing;
    reviewsList.creditsLeft = payload.creditsLeft;
    reviewsList.importQuota = payload.importQuota;
    reviewsList.loading = false;
    reviewsList.progression = payload.progression ? payload.progression : null;
    if (reviewsList.selectedProduct) {
      reviewsList.selectedProduct.allReviewsCount = payload.recordsTotal;
      reviewsList.selectedProduct.reviewNumber = payload.recordsTotal;
      reviewsList.selectedProduct.unpublishedCount = payload.numUnpublished;
    }
  },
  setReviewsListPaginationPage({ reviewsList }, payload) {
    reviewsList.pagination.page = payload;
  },
  setReviewsListSearch({ reviewsList }, payload) {
    reviewsList.pagination.search = payload;
  },
  setReviewsListFilter({ reviewsList }, payload) {
    reviewsList.pagination.filterBy = payload;
  },

  setSellerReviewsPagination({ sellerReviews }, payload) {
    sellerReviews.pagination.search = payload.search;
    sellerReviews.pagination.descending = payload.descending;
    sellerReviews.pagination.page = payload.page;
    sellerReviews.pagination.rowsPerPage = payload.rowsPerPage;
    sellerReviews.pagination.approved = payload.approved;
    sellerReviews.pagination.source = payload.source;
    sellerReviews.pagination.filterBy = payload.filterBy;
    sellerReviews.pagination.startDate = payload.startDate;
    sellerReviews.pagination.endDate = payload.endDate;
    sellerReviews.pagination.stars = payload.stars;
  },
  setSellerReviewsLoading({ sellerReviews }, loading) {
    sellerReviews.loading = loading;
  },
  setSellerPaginationPage({ sellerReviews }, payload) {
    sellerReviews.pagination.page = payload;
  },
  loadSellerReviewsSuccess({ sellerReviews, reviewsList }, payload) {
    sellerReviews.loading = false;
    sellerReviews.items = payload.items;
    sellerReviews.numUnapproved = payload.numUnapproved;
    sellerReviews.amazonSellerReviewsTotal = payload.amazonSellerReviewsTotal;
    sellerReviews.ebaySellerReviewsTotal = payload.ebaySellerReviewsTotal;
    sellerReviews.pagination.rowsPerPage = payload.dashboardReviewsPerPage;
    reviewsList.pagination.rowsPerPage = payload.dashboardReviewsPerPage;
    sellerReviews.reviewsTotal = payload.sellerReviewsTotal;
    sellerReviews.pagination.totalItems = payload.recordsTotal;
    sellerReviews.importing = payload.importing;
  },
  setProductSearchLoading({ productSearch }, loading) {
    productSearch.loading = loading;
  },
  searchProductsSuccess({ productSearch }, payload) {
    productSearch.loading = false;
    productSearch.items = payload.data;

    const fullUniqueList = productSearch.allItems
      .concat(payload.data || [])
      .reduce((list, item) => {
        if (!list.find(el => el.id == item.id)) {
          list.push(item);
        }
        return list;
      }, []);

    productSearch.allItems = fullUniqueList;
  },
  setProductSearch(state, payload) {
    state.productSearch = payload;
  },
  setProductSearchSelected: ({ productSearch }, payload) => {
    productSearch.selected = payload;
  },

  setMoveProductSearchLoading({ moveProductSearch }, loading) {
    moveProductSearch.loading = loading;
  },
  searchMoveProductsSuccess({ moveProductSearch }, payload) {
    moveProductSearch.loading = false;
    moveProductSearch.items = payload.data;
  },
  hideLinkReviews({ productSearch }) {
    productSearch.show = false;
  },
};
